import { Injectable } from '@angular/core';
import { ListHelperService, ProfileService, StoreService } from 'core/services';
import { TranslateService } from '@ngx-translate/core';
import { TableDatasource, DataTypes } from '@gamelearn/skeletor/models';
import { MarsGroupService } from '../../../services/mars-groups.service';
import { MarsGroup } from 'app/mars/models/MarsGroup';

@Injectable()
export class MarsGroupSurveysListService {
  userRole: any;
  player: any;
  dataSource: any;
  mode: string = 'view';
  constructor(
    public marsGroupService: MarsGroupService,
    public translate: TranslateService,
    public profileService: ProfileService,
    public listHelper: ListHelperService
  ) {}

  async getDatasource(listId, group: any) {
    this.dataSource = new TableDatasource({
      sort: '-survey.date',
      columns: this.getColumns(),
      load: (props) => this.fetch(props, this.dataSource, group),
      storeState: {
        enabled: true,
        key: `${listId}_${this.profileService.getLoggedUserRole().name}`
      }
    });
    await this.dataSource.refreshData();
    StoreService.create(listId, this.dataSource);
    return this.dataSource;
  }

  fetch({ page, limit, sort, filters }, dataSource: TableDatasource, group: MarsGroup) {
    const $filter = this.listHelper.buildFilterString(filters, dataSource, this.getCustomFilters());
    const paginationOptions = {
      page,
      limit,
      sort,
      $filter
    };
    return this.marsGroupService.getGroupSurveys(group.id, paginationOptions).then((response) => response);
  }

  getDatasourceFilters(dataSource: TableDatasource) {
    const $filter = this.listHelper.buildFilterString(dataSource.filters, dataSource, this.getCustomFilters());
    return {
      $filter
    };
  }

  getColumns() {
    const columns = [
      {
        source: 'name',
        label: this.translate.instant('nouns.name'),
        sortable: true,
        valueParser: (value) => {
          return value || '-';
        }
      },
      {
        source: 'surname',
        label: this.translate.instant('nouns.surname'),
        sortable: true,
        valueParser: (value) => {
          return value || '-';
        }
      },
      {
        source: 'userEmail',
        label: this.translate.instant('nouns.email'),
        sortable: true,
        cellRenderer: (renderer, value) => renderer`<div class="ellipsis" title="${value}">${value}</div>`
      },
      {
        source: 'survey.date',
        label: this.translate.instant('reports.columns.register_date'),
        dataType: DataTypes.datetime,
        sortable: true
      },
      {
        source: 'survey.opinion',
        label: this.translate.instant('reports.columns.opinion'),
        dataType: DataTypes.number,
        sortable: true,
        alignment: 'right',
        comparators: ['EQUAL', 'LESS_THAN', 'GREATER_THAN']
      },
      {
        source: 'survey.applicable',
        label: this.translate.instant('reports.columns.applicable'),
        dataType: DataTypes.boolean,
        alignment: 'center'
      },
      {
        source: 'survey.comments',
        label: this.translate.instant('reports.columns.comments'),
        allowFiltering: false
      },
      {
        source: 'survey.suggestions',
        label: this.translate.instant('reports.columns.suggestions'),
        allowFiltering: false
      }
    ].filter((column) => !!column);
    return columns;
  }

  getCustomFilters() {
    return {
      // tags: (filterBuilder, value) => (value ? value.forEach((v) => filterBuilder.contains('tags', v)) : null)
    };
  }
}
